import React from 'react'
import Header from '../components/header'
import BreadCrumb from '../components/BreadCrumb'
import AboutArea from '../components/AboutArea'
import CounterArea from '../components/CounterArea'
import DownloadArea from '../components/DownloadArea'
import GoogleMap from '../components/GoogleMap'
import Footer from '../components/footer'

function TaxiDoPage() {
  const pageName="TaxiDo"
  return (
    <div className='home-3'>
      <Header/>
      <BreadCrumb pageName={pageName}/>
      <main>
        <AboutArea/>
        <CounterArea/>
        <DownloadArea/>
        <GoogleMap/>
      </main>
      <Footer/>
    </div>
  )
}

export default TaxiDoPage